export const toBrlValue = (input: number): string =>
  input
    .toLocaleString("pt-br", {style: "currency", currency: "BRL"})
    .replace(" ", " ");
